import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
width:100%;


font-size: 11px;
text-align:left;
color: ${theme.colors.dark};

`;

export const Title = styled.span`
font-size: 12px;
font-weight: bold;
`;

export const ContainerInterno = styled.div`
width:100%;



`;
export const Section = styled.section`
    display:flex;
    align-items: center;
    justify-content:space-between;
margin-bottom:0.4vh ;
`;




export const ContainerValue = styled.div`

width:100%;
display: flex;
align-items: flex-start;
flex-direction: column;
font-size: 12px;
white-space:nowrap ;
font-weight: bold;
`;

export const Values = styled.div`
    width:100%;
    border:solid 1px ${theme.colors.dark};
    padding: 0.5vh 1vw;
    font-size: 11px;
    font-weight: normal;
`;



